import { formatISO as formatFns } from 'date-fns';

export default function formatISO(date: Date): string {
  return formatFns(date);
}
